import React, { useEffect } from "react";
import Api from "../Hooks/Api"
const HomePage = () => {
  const logout = () => {
    let UserId = window.sessionStorage.getItem("UserId");
    let SecurityGroupId = window.sessionStorage.getItem("SecurityGroupId");
    if (SecurityGroupId == "1") {
      let url = "/api/login/" + UserId + "/student";
      Api.put(url)
        .then(function (response) {
        })
        .catch(function (error) {
          // handle error
        })
        .then(function () {
          // always executed
        })
    } else {
      let url = "/api/login/" + UserId + "/users";
      Api.put(url)
        .then(function (response) {
        })
        .catch(function (error) {
          // handle error

        })
        .then(function () {
          // always executed
        })
    }

    //window.sessionStorage.clear();
    //localStorage.clear();
  };
  const onUnload = e => {
    e.preventDefault();
    let xtoken = window.sessionStorage.getItem("xtoken");
    if (xtoken) {
      logout();
    }
    //return "This page is asking you to confirm that you want to leave — information you’ve entered may not be saved.";
  };
  useEffect(() => {
    // const onUnload = cb.current;
    window.addEventListener('beforeunload', onUnload);
    return () => {
      window.removeEventListener('beforeunload', onUnload);
    };
  }, []);
  return (
    <div id="header" className="header navbar-default">
      <div className="navbar-header">
        <a className="navbar-brand">
          <span className="navbar-logo"></span>{" "}
          <b>NATIONAL TOURISM SERVICE PORTAL (NTSP)</b>


        </a>
        <button
          type="button"
          className="navbar-toggle"
          data-click="sidebar-toggled"
        >
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
      </div>

      <ul className="navbar-nav navbar-right">
        <li className="navbar-form">
          <b>{window.sessionStorage.getItem("Institutionname")}</b>

        </li>

        <li className="dropdown navbar-user">
          <a href="#" className="dropdown-toggle" data-toggle="dropdown">
            <img
              src={
                process.env.REACT_APP_BASE_URL + 'api/' + window.sessionStorage.getItem("Photo")
              }
              alt=""
            />
            <span className="d-none d-md-inline">
              {window.sessionStorage.getItem("UserName")}
            </span>{" "}
            <b className="caret"></b>
          </a>
          <div className="dropdown-menu dropdown-menu-right">
            <a href="#/EditProfile" className="dropdown-item">
              Edit Profile
            </a>
            <div className="dropdown-divider"></div>
            <a href="#Logout" className="dropdown-item">
              Log Out
            </a>
          </div>
        </li>
      </ul>
    </div>
  );
};
export default HomePage;
